<template>
    <div class="container">

        <div class="wrap">

            <div class="header">宿舍管理</div>
            <div class="content">
                <div class="school-name" v-show="infos.schoolName">{{ infos.schoolName || '' }}</div>
                <div class="date-time" v-show="currentTime">{{ currentTime }}</div>

                <div class="con-block">
                    <div class="block-item-wrap">
                        <div class="block-item">
                            <div class="block-title">寄宿学生</div>
                            <div class="block-mes-wrap">
                                <div class="block-mes">
                                    <div class="block-num">
                                        <span>{{ infos.maleStuCount || 0 }}</span>
                                        <span>人</span>
                                    </div>
                                    <div class="block-unit">男生</div>
                                </div>
                                <div class="block-mes">
                                    <div class="block-num">
                                        <span>{{ infos.femaleStuCount || 0 }}</span>
                                        <span>人</span>
                                    </div>
                                    <div class="block-unit">女生</div>
                                </div>
                                <div class="block-mes">
                                    <div class="block-num">
                                        <span>{{ infos.allStuCount || 0 }}</span>
                                        <span>人</span>
                                    </div>
                                    <div class="block-unit">合计</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="block-item-wrap">
                        <div class="block-item">
                            <div class="block-title">宿舍楼</div>
                            <div class="block-mes-wrap">
                                <div class="block-mes">
                                    <div class="block-num">
                                        <span>{{ infos.maleDormNum || 0 }}</span>
                                        <span>栋</span>
                                    </div>
                                    <div class="block-unit">男生宿舍</div>
                                </div>
                                <div class="block-mes">
                                    <div class="block-num">
                                        <span>{{ infos.femaleDormNum || 0 }}</span>
                                        <span>栋</span>
                                    </div>
                                    <div class="block-unit">女生宿舍</div>
                                </div>
                                <div class="block-mes">
                                    <div class="block-num">
                                        <span>{{ infos.allDormNum || 0 }}</span>
                                        <span>栋</span>
                                    </div>
                                    <div class="block-unit">合计</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="block-item-wrap">
                        <div class="block-item">
                            <div class="block-title">寄宿生今日请假</div>
                            <div class="block-mes-wrap one">
                                <div class="block-mes">
                                    <div class="block-num">
                                        <span>{{ infos.leaveNum || 0 }}</span>
                                        <span>人</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="block-item-wrap">
                        <div class="block-item">
                            <div class="block-title">在舍人数估算</div>
                            <div class="block-mes-wrap one">
                                <div class="block-mes">
                                    <div class="block-num">
                                        <span>{{ infos.inNum || 0 }}</span>
                                        <span>人</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="con-sign">
                    <div class="cont-title">宿舍出入签到</div>
                    <div class="block-wrap">
                        <div class="con-block-wrap">
                            <div class="con-block-inner">
                                <div class="con-title">上午离舍 {{ infos.morOutTime || '' }}</div>
                                <div class="con-mes">
                                    <div class="con-mes-txt">
                                        <span>已签到</span>
                                        <span>{{ infos.morOutYesCount || 0 }}</span>
                                        <span>人</span>
                                    </div>
                                    <div class="con-mes-txt">
                                        <span>未签到</span>
                                        <span>{{ subtractNum(infos.allStuCount, infos.morOutYesCount) }}</span>
                                        <span>人</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="con-block-wrap">
                            <div class="con-block-inner">
                                <div class="con-title">中午回舍 {{ infos.morBackTime || '' }}</div>
                                <div class="con-mes">
                                    <div class="con-mes-txt">
                                        <span>已签到</span>
                                        <span>{{ infos.morBackYesCount || 0 }}</span>
                                        <span>人</span>
                                    </div>
                                    <div class="con-mes-txt">
                                        <span>未签到</span>
                                        <span>{{ subtractNum(infos.allStuCount, infos.morBackYesCount) }}</span>
                                        <span>人</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="con-block-wrap">
                            <div class="con-block-inner">
                                <div class="con-title">下午离舍 {{ infos.afterOutTime || '' }}</div>
                                <div class="con-mes">
                                    <div class="con-mes-txt">
                                        <span>已签到</span>
                                        <span>{{ infos.afterOutYesCount || 0 }}</span>
                                        <span>人</span>
                                    </div>
                                    <div class="con-mes-txt">
                                        <span>未签到</span>
                                        <span>{{ subtractNum(infos.allStuCount, infos.afterOutYesCount) }}</span>
                                        <span>人</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="con-block-wrap">
                            <div class="con-block-inner">
                                <div class="con-title">晚上回舍 {{ infos.nightBackTime || '' }}</div>
                                <div class="con-mes">
                                    <div class="con-mes-txt">
                                        <span>已签到</span>
                                        <span>{{ infos.nightBackYesCount || 0 }}</span>
                                        <span>人</span>
                                    </div>
                                    <div class="con-mes-txt">
                                        <span>未签到</span>
                                        <span>{{ subtractNum(infos.allStuCount, infos.nightBackYesCount) }}</span>
                                        <span>人</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- start -->
                <div class="con-stay">
                    <div class="title-wrap">
                        <div class="cont-title">在校留宿</div>
                        <div class="sub-title">
                            <span>申请今日留宿学生</span>
                            <span>{{ infos.stayDormCount || 0 }}</span>
                            <span>人</span>
                        </div>
                    </div>
                    <div class="tips">留宿学生签到情况</div>
                    <div class="block-wrap">
                        <div class="con-block-wrap">
                            <div class="con-block-inner">
                                <div class="con-title">下午离舍 {{ infos.afterOutTime || '' }}</div>
                                <div class="con-mes">
                                    <div class="con-mes-txt">
                                        <span>已签到</span>
                                        <span>{{ infos.afterOutStayCount || 0 }}</span>
                                        <span>人</span>
                                    </div>
                                    <div class="con-mes-txt">
                                        <span>未签到</span>
                                        <span>{{ subtractNum(infos.stayDormCount, infos.afterOutStayCount) }}</span>
                                        <span>人</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="con-block-wrap">
                            <div class="con-block-inner">
                                <div class="con-title">晚上回舍 {{ infos.nightBackTime || '' }}</div>
                                <div class="con-mes">
                                    <div class="con-mes-txt">
                                        <span>已签到</span>
                                        <span>{{ infos.nightBackStayCount || 0 }}</span>
                                        <span>人</span>
                                    </div>
                                    <div class="con-mes-txt">
                                        <span>未签到</span>
                                        <span>{{ subtractNum(infos.stayDormCount, infos.nightBackStayCount) }}</span>
                                        <span>人</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- end -->

            </div>

        </div>
    </div>
</template>
<script>
import { formatTime } from '@/assets/js/common'
export default {
    data() {
        return {
            companyId: '',
            currentTime: '',
            currTimer: '',
            infos: {},
            circulate: 0, // 定时器循环请求
            circulTimer: '',
        }
    },
    components: {},
    computed: {},
    // 监听路由后缀变化
    watch: {
        $route: {
            deep: true,
            immediate: true,
            handler(to) {
                console.log('==>route<==')
                if (Object.keys(to.query).length > 0) {
                    this.companyId = to.query.companyId
                    this.circulate = to.query.circulate || 0
                    if (['IndexDorm'].includes(to.name)) {
                        this.initData()
                    }
                }
            }
        },
        circulate: {
            deep: true,
            immediate: true,
            handler(newVal) {
                const minute = parseInt(newVal)
                if (minute && minute > 0) {
                    console.log('===>触发watch circulate<===', minute)
                    clearInterval(this.circulTimer)
                    this.circulTimer = setInterval(() => {
                        this.initData()
                    }, minute * 60 * 1000)
                }
            },
        },
    },
    beforeCreate() {
        clearInterval(this.circulTimer)
    },
    beforeUpdate() {
        this.loopTime()
    },
    created() { },
    methods: {
        initData() {
            console.log('===>触发initData<==', this.currentTime)
            this.$get(this.$api.getDormitoryScreenLoadInfo, {
                companyId: this.companyId,
            }).then(res => {
                if (res.success) {
                    this.infos = res.result || {}
                }
            }).catch(() => {
                this.loopTime()
            })
        },
        loopTime() {
            clearInterval(this.currTimer)
            this.currTimer = setInterval(() => {
                const nowDate = new Date()
                const week = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"][nowDate.getDay()]
                this.currentTime = `${formatTime(nowDate, 'yyyy年MM月dd日 HH:mm:ss')} ${week}`
            }, 1000)
        },
        
        // 相减
        subtractNum(numA, numB) {
            try {
                const numC = parseInt(numA) - parseInt(numB)
                if (typeof numC === 'number' && !isNaN(numC)) {
                    return numC
                }
                return 0
            } catch (error) {
                return 0
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.container {
    padding: vh(50) vh(20) 0;
    position: relative;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: url(../../assets/images/dorm/dorm_bg.png) no-repeat;
    background-size: 100% 100%;

    .wrap {
        max-width: vh(660);
        margin: auto;
    }

    .header {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        text-align: center;
        font-weight: bold;
        font-size: vh(30);
        color: #fff;
        background: url(../../assets/images/dorm/dorm_title.png) no-repeat;
        background-size: 100% 100%;
        height: vh(69);
        padding: vh(14) 0;
        line-height: 1;
    }

    @mixin block-flex-width {
        width: 49%;
    }

    @mixin block-magin-style {
        margin-bottom: vh(10);
    }

    @mixin block-wrap-style {
        background: url(../../assets/images/dorm/dorm_block.png) no-repeat;
        background-size: 100% 100%;
        min-height: vh(120);
        @include block-magin-style;
    }

    @mixin block-inner-style {
        display: flex;

        >div {
            flex: 1;
        }
    }

    @mixin block-title-style {
        text-align: center;
        font-size: vh(18);
        font-weight: bold;
        line-height: 1;
        padding: vh(10) 0 0;
        color: #fff;
    }

    .content {
        position: relative;
        background: linear-gradient(180deg, #7DA4EE 1%, #fff 6%);
        padding: vh(44) vh(10) vh(30);
        border-radius: vh(10);
        margin-top: vh(40);
        box-shadow: vh(2) 0 vh(6) 0 #A0ACCA;

        .school-name {
            position: absolute;
            top: vh(-16);
            left: vh(24);
            background: url(../../assets/images/dorm/dorm_school.png) no-repeat;
            background-size: 100% 100%;
            color: #fff;
            padding: vh(10) vh(20) vh(16);
            min-width: vh(212);
            text-align: center;
        }

        .date-time {
            position: absolute;
            top: 0;
            right: 0;
            color: #fff;
            padding: vh(6) vh(10);
            line-height: 1;
            background: #2545CE;
            box-shadow: vh(2) 0 vh(6) 0 #A0ACCA;
            border-radius: vh(15);
            transform: translateY(-50%);
        }

        .con-block {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            .block-item-wrap {
                @include block-flex-width;
            }

            .block-item {
                @include block-wrap-style;

                .block-title {
                    @include block-title-style;
                }

                .block-mes-wrap {
                    @include block-inner-style;
                    padding: vh(24) vh(10) vh(20);

                    .block-mes {
                        text-align: center;

                        .block-num {
                            font-weight: bold;
                        }

                        .block-num>span:first-of-type {
                            font-size: vh(22);
                        }

                        .block-num>span:last-of-type {
                            font-size: vh(12);
                        }

                        .block-unit {
                            font-size: vh(12);
                            margin-top: vh(10);
                        }
                    }

                    &.one {
                        justify-content: center;
                        font-size: vh(30);
                        color: #333333;

                        .block-num>span:first-of-type {
                            font-size: vh(30) !important;
                        }
                    }
                }
            }
        }

        .con-stay {
            .title-wrap {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .sub-title {
                    font-size: vh(15);
                    color: #fff;
                    padding: vh(1) vh(10) vh(6);
                    line-height: 1;
                    background: #2545CE;
                    box-shadow: vh(2) 0 vh(6) 0 #A0ACCA;
                    border-radius: vh(15);

                    >span:nth-of-type(2) {
                        font-size: vh(22);
                        margin: 0 vh(3);
                    }
                }
            }
        }

        .tips {
            font-size: vh(16);
            font-weight: bold;
            text-align: center;
            margin: vh(26) 0 vh(14);
        }

        .con-sign,
        .con-stay {
            margin-top: vh(20);
            border-top: vh(1) solid #ccc;
            padding-top: vh(15);

            .cont-title {
                font-size: vh(22);
                font-weight: bold;
                padding-left: vh(14);
                padding-bottom: vh(4);
                background: url(../../assets/images/dorm/dorm_icon.png) no-repeat;
                background-size: vh(4) 100%;
                line-height: 1;
                margin: vh(10) vh(4);
            }

            .block-wrap {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;

                .con-block-wrap {
                    @include block-flex-width;
                }

                .con-block-inner {
                    @include block-wrap-style;

                    .con-title {
                        @include block-title-style;
                    }

                    .con-mes {
                        @include block-inner-style;
                        padding: vh(30) vh(10) vh(36);

                        .con-mes-txt {
                            text-align: center;

                            >span:nth-of-type(2) {
                                font-size: vh(24);
                                font-weight: bold;
                                margin: 0 vh(2);
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>